import { useEffect, useState } from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import { useFeatureFlagsProvider } from './feature-flags.provider';
import { getTenantName } from '@/utils';
import { isGbiUser } from './feature-flags.utils';
import { useSessionAreaName, useSessionCollectionName } from '@/platform-services/session';
export const FeatureFlagsUpdateContext = ({ children }) => {
    const { featureFlagsService } = useFeatureFlagsProvider();
    const areaName = useSessionAreaName();
    const tenantName = getTenantName();
    const collection = useSessionCollectionName();
    const { user: auth0User } = useAuth0();
    const [flagContextUser, setFlagContextUser] = useState();
    useEffect(() => {
        void featureFlagsService.updateFeatureFlagsContext({
            user: flagContextUser,
            configuration: {
                area: areaName,
                collection,
            },
        });
    }, [featureFlagsService, areaName, collection, flagContextUser]);
    useEffect(() => {
        if (auth0User && tenantName) {
            const contextUser = {
                name: auth0User.name,
                email: auth0User.email,
                tenantName,
                isGBIUser: isGbiUser(auth0User.email),
            };
            setFlagContextUser(contextUser);
        }
    }, [
        tenantName,
        auth0User,
    ]);
    return children;
};
